// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__eK45y","select":"style_select__bI+bA"};